<ambita-landregistry-right-selector>
  <div>
    <form class="ambita-landregistry-selector__cadastre-key" onsubmit="{ formSubmit }">
      <input class="ambita-landregistry-selector__cadastre-key" if="{ isValidTokenAvailable }" ref="numberInput"
             placeholder="<embete>-<år>-<dokumentnr>-<rettsstiftelseløpenr>"/>
      <input class="ambita-landregistry-selector__cadastre-key" if="{ !isValidTokenAvailable }"
             placeholder="{ i18n.common.loginRequired }" disabled/>
    </form>
  </div>

  <script>
    import '../../i18n/commonTranslations';
    import { init } from './landRegistryRightSelectorController';

    init(this);
  </script>
</ambita-landregistry-right-selector>
